import { Dialog, DialogActions, DialogContent, Grid, Stack, Typography } from "@mui/material";
import { APP_NAME } from "app/appConstants";
import { MprcDialogTitleClose } from "components/MprcDialogTitleClose";
import { MprcRequestErrorReport } from "components/MprcRequestErrorReport";
import { MprcRequestIndicator } from "components/MprcRequestIndicator";
import { AboutInfoDto } from "generated/CoreApi_v1";
import moment from "moment";
import { useCoreApi } from "providers/CoreApiProvider";
import { useSession } from "providers/SessionProvider";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    onClose: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////

export const AboutDialog: React.FC<IProps> = ({ onClose }) => {

    /////////////////////////////////////////////////////////////////////////////////////
    const { t } = useTranslation();
    const api = useCoreApi();

    const [loading, setLoading] = useState<boolean>(true);
    const data = useRef<AboutInfoDto>(null!);
    const lastError = useRef<any>(null);
    const { appBuild } = useSession();

    useEffect(() => {
        async function loadData() {
            try {
                var result = await api.v1.system.aboutInfo();
                data.current = result.data;
            } catch (error) {
                lastError.current = error;
            }
            finally {
                setLoading(false);
            }
        }
        loadData();
    }, []);

    return (
        <Dialog
            open
            fullWidth
            onClose={onClose}
            maxWidth="sm"
            role="dialog"
        >
            <MprcDialogTitleClose title={t("Public.About.Title")} onClose={onClose} shrinkPadding />

            <DialogContent>
                {
                    lastError.current
                        ? <MprcRequestErrorReport error={lastError.current} />
                        : loading
                            ? <MprcRequestIndicator type="request" />
                            : (
                                <div>
                                    <Grid container justifyContent="center" alignItems="center" spacing={10}>

                                        <Grid>
                                            <img src={"/img/app/App-Logo-About.png"} alt={APP_NAME} width={192} height={192} />
                                        </Grid>

                                        <Grid size="grow">
                                            {
                                                lastError.current
                                                    ? <MprcRequestErrorReport error={lastError.current} />
                                                    : (
                                                        <Stack direction="column" spacing={3} alignItems="center" textAlign="center">
                                                            {appBuild &&
                                                                <Typography variant="body2">
                                                                    <strong>
                                                                        {t("Public.ReleaseNotes.CurrentAppRelease")}:&nbsp;{appBuild?.buildVersion}
                                                                    </strong>
                                                                    <br />
                                                                    {appBuild?.timestamp &&
                                                                        <Typography variant="caption">
                                                                            {moment(appBuild.timestamp).format("yyyy-MM-DD HH:mm")}
                                                                        </Typography>
                                                                    }
                                                                </Typography>
                                                            }

                                                            <Typography variant="body2">
                                                                <strong>{t("Public.ReleaseNotes.CurrentApiRelease")}:&nbsp;{data.current.version}</strong>
                                                                <br />
                                                                <Typography variant="caption">
                                                                    {moment(data.current.buildDate).format("yyyy-MM-DD HH:mm")}
                                                                </Typography>
                                                            </Typography>
                                                            <Typography variant="subtitle1">
                                                                Copyright &copy; {data.current.copyright}&nbsp;{data.current.company}<br />
                                                                {t("Public.About.AllRightsReserved")}
                                                            </Typography>
                                                        </Stack>
                                                    )
                                            }
                                        </Grid>
                                    </Grid>

                                </div>
                            )
                }
            </DialogContent>
            <DialogActions />
        </Dialog >
    );
};
